//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSourceType } from './Enums';

export class PayPalCommercePlatformCreateOrderInputItem extends ItemBase {
    Total: number = 0;
    Surcharge: number | null = null;
    FamilyID: string | null = null;
    ParentID: string | null = null;
    PostalCode: string | null = null;
    CountryCode: string | null = null;
    ProvStateCode: string | null = null;
    Vault: boolean = false;
    AutoPay: boolean = false;
    ReturnURL: string | null = null;
    PaymentSourceType: PaymentSourceType = PaymentSourceType.BankAccount;

    constructor(initializer?: Partial<PayPalCommercePlatformCreateOrderInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PayPalCommercePlatformCreateOrderInputItem";
}
